// DELETE Executions:
export const DELETE_EXECUTION_START = "DELETE_EXECUTION_START";
export const DELETE_EXECUTION_SUCCESS = "DELETE_EXECUTION_SUCCESS";
export const DELETE_EXECUTION_FAIL = "DELETE_EXECUTION_FAIL";
/******* USER SIGNUP ********/
export const REQUEST_SIGNUP_START = "REQUEST_SIGNUP_START";
export const REQUEST_SIGNUP_SUCCESS = "REQUEST_SIGNUP_SUCCESS";
export const REQUEST_SIGNUP_FAIL = "REQUEST_SIGNUP_FAIL";

export const REQUEST_SIGNIN_START = "REQUEST_SIGNIN_START";
export const REQUEST_SIGNIN_SUCCESS = "REQUEST_SIGNIN_SUCCESS";
export const REQUEST_SIGNIN_FAIL = "REQUEST_SIGNIN_FAIL";

export const SOCIAL_AUTH_START = "SOCIAL_AUTH_START";
export const SOCIAL_AUTH_SUCCESS = "SOCIAL_AUTH_SUCCESS";
export const SOCIAL_AUTH_FAIL = "SOCIAL_AUTH_FAIL";

export const GITHUB_LINK_START = "GITHUB_LINK_START";
export const GITHUB_LINK_SUCCESS = "GITHUB_LINK_SUCCESS";
export const GITHUB_LINK_FAIL = "GITHUB_LINK_FAIL";

export const RECOVER_PASSWORD_START = "RECOVER_PASSWORD_START";
export const RECOVER_PASSWORD_SUCCESS = "RECOVER_PASSWORD_SUCCESS";
export const RECOVER_PASSWORD_FAIL = "RECOVER_PASSWORD_FAIL";

export const REQUEST_SIGN_OUT = "REQUEST_SIGN_OUT";

export const ACTIVATE_ACCOUNT_START = "ACTIVATE_ACCOUNT_START";
export const ACTIVATE_ACCOUNT_SUCCESS = "ACTIVATE_ACCOUNT_SUCCESS";
export const ACTIVATE_ACCOUNT_FAIL = "ACTIVATE_ACCOUNT_FAIL";

export const RESEND_ACTIVATION_START = "RESEND_ACTIVATION_START";
export const RESEND_ACTIVATION_SUCCESS = "RESEND_ACTIVATION_SUCCESS";
export const RESEND_ACTIVATION_FAIL = "RESEND_ACTIVATION_FAIL";

/******* REINIT *******/
export const REINIT_RUNNING_EXECUTION = "REINIT_RUNNING_EXECUTION";
/************* Fetch data set */
export const FETCH_MY_DATASET_START = "FETCH_MY_DATASET_START";
export const FETCH_MY_DATASET_SUCCESS = "FETCH_MY_DATASET_SUCCESS";
export const FETCH_MY_DATASET_FAIL = "FETCH_MY_DATASET_FAIL";

export const RESET_DATASETS = "RESET_DATASETS";

/************* delete data set */
export const DELETE_DATASET_START = "DELETE_DATASET_START";
export const DELETE_DATASET_SUCCESS = "DELETE_DATASET_SUCCESS";
export const DELETE_DATASET_FAIL = "DELETE_DATASET_FAIL";

/************** add favorite dataset */

export const ADD_FAVORITE_DATASET_START = "ADD_FAVORITE_DATASET_START";
export const ADD_FAVORITE_DATASET_SUCCESS = "ADD_FAVORITE_DATASET_SUCCESS";
export const ADD_FAVORITE_DATASET_FAIL = "ADD_FAVORITE_DATASET_FAIL";

/******************fetch single dataset */

export const FETCH_SINGLE_DATASET_START = "FETCH_SINGLE_DATASET_START";
export const FETCH_SINGLE_DATASET_FAIL = "FETCH_SINGLE_DATASET_FAIL";
export const FETCH_SINGLE_DATASET_SUCCESS = "FETCH_SINGLE_DATASET_SUCCESS";

export const FETCH_SINGLE_SENSOR_START = "FETCH_SINGLE_SENSOR_START";
export const FETCH_SINGLE_SENSOR_FAIL = "FETCH_SINGLE_SENSOR_FAIL";
export const FETCH_SINGLE_SENSOR_SUCCESS = "FETCH_SINGLE_SENSOR_SUCCESS";

export const FETCH_SINGLE_TIME_START = "FETCH_SINGLE_TIME_START";
export const FETCH_SINGLE_TIME_FAIL = "FETCH_SINGLE_TIME_FAIL";
export const FETCH_SINGLE_TIME_SUCCESS = "FETCH_SINGLE_TIME_SUCCESS";

export const REINIT_SINGLE_DATA_SET = "REINIT_SINGLE_DATA_SET";

/****************** update dataset *****************/
export const UPDATE_DATASET_START = "UPDATE_DATASET_START";
export const UPDATE_DATASET_FAIL = "UPDATE_DATASET_FAIL";
export const UPDATE_DATASET_SUCCESS = "UPDATE_DATASET_SUCCESS";
export const UPDATE_DATASET_TASK = "UPDATE_DATASET_TASK";
/****************** label dataset *****************/
export const LABEL_DATASET_START = "LABEL_DATASET_START";
export const LABEL_DATASET_FAIL = "LABEL_DATASET_FAIL";
export const LABEL_DATASET_SUCCESS = "LABEL_DATASET_SUCCESS";

/************* Fetch my files */
export const FETCH_MY_FILES_START = "FETCH_MY_FILES_START";
export const FETCH_MY_FILES_SUCCESS = "FETCH_MY_FILES_SUCCESS";
export const FETCH_MY_FILES_FAIL = "FETCH_MY_FILES_FAIL";

/************** fetch my models */

export const FETCH_MY_MODELS_SUCCESS = "FETCH_MY_MODELS_SUCCESS";
export const FETCH_MY_MODELS_START = "FETCH_MY_MODELS_START";
export const FETCH_MY_MODELS_FAIL = "FETCH_MY_MODELS_FAIL";

/*********************delete file *************/
export const DELETE_FILES_START = "DELETE_FILES_START";
export const DELETE_FILES_SUCCESS = "DELETE_FILES_SUCCESS";
export const DELETE_FILES_FAIL = "DELETE_FILES_FAIL";

/************************delete model *************/
export const DELETE_MODEL_START = "DELETE_MODEL_START";
export const DELETE_MODEL_SUCCESS = "DELETE_MODEL_SUCCESS";
export const DELETE_MODEL_FAIL = "DELETE_MODEL_FAIL";

/*********** fetch single data */
export const FETCH_SINGLE_MODEL_START = "FETCH_SINGLE_MODEL_START";
export const FETCH_SINGLE_MODEL_FAIL = "FETCH_SINGLE_MODEL_FAIL";
export const FETCH_SINGLE_MODEL_SUCCESS = "FETCH_SINGLE_MODEL_SUCCESS";

/**************update model  ***************/
export const UPDATE_MODEL_START = "UPDATE_MODEL_START";
export const UPDATE_MODEL_FAIL = "UPDATE_MODEL_FAIL";
export const UPDATE_MODEL_SUCCESS = "UPDATE_MODEL_SUCCESS";

/****************  fetch single file ************/
export const FETCH_SINGLE_FILE_START = "FETCH_SINGLE_FILE_START";
export const FETCH_SINGLE_FILE_FAIL = "FETCH_SINGLE_FILE_FAIL";
export const FETCH_SINGLE_FILE_SUCCESS = "FETCH_SINGLE_FILE_SUCCESS";
export const FETCH_PLOT_FILE_SUCCESS = "FETCH_PLOT_FILE_SUCCESS";

/****************  fetch single file download url ************/
export const FETCH_FILE_DOWNLOAD_URL = "FETCH_FILE_DOWNLOAD_URL";
export const FETCH_FILE_DOWNLOAD_URL_START = "FETCH_FILE_DOWNLOAD_URL_START";
export const FETCH_FILE_DOWNLOAD_URL_SUCCESS = "FETCH_FILE_DOWNLOAD_URL_SUCCESS";
export const FETCH_FILE_DOWNLOAD_URL_FAIL = "FETCH_FILE_DOWNLOAD_URL_FAIL";

/******************update file  ***************/
export const UPDATE_FILE_START = "UPDATE_FILE_START";
export const UPDATE_FILE_FAIL = "UPDATE_FILE_FAIL";
export const UPDATE_FILE_SUCCESS = "UPDATE_FILE_SUCCESS";

/*****************add model favorite ******************/
export const ADD_FAVORITE_MODEL_START = "ADD_FAVORITE_MODEL_START";
export const ADD_FAVORITE_MODEL_SUCCESS = "ADD_FAVORITE_MODEL_SUCCESS";
export const ADD_FAVORITE_MODEL_FAIL = "ADD_FAVORITE_MODEL_FAIL";

/*****************add file favorite ******************/
export const ADD_FAVORITE_FILE_START = "ADD_FAVORITE_FILE_START";
export const ADD_FAVORITE_FILE_SUCCESS = "ADD_FAVORITE_FILE_SUCCESS";
export const ADD_FAVORITE_FILE_FAIL = "ADD_FAVORITE_FILE_FAIL";

/*****************fetch user info ******************/
export const FETCH_USER_INFO_START = "FETCH_USER_INFO_START";
export const FETCH_USER_INFO_SUCCESS = "FETCH_USER_INFO_SUCCESS";
export const FETCH_USER_INFO_FAIL = "FETCH_USER_INFO_FAIL";

/****** AJAX RESPONSE ACTIONS *****/
export const SUCCESS_MESSAGE = "SUCCESS_MESSAGE";
export const ERORR_MESSAGE = "ERORR_MESSAGE";
export const INFO_MESSAGE = "INFO_MESSAGE";
export const PAGE_NOT_FOUND = "PAGE_NOT_FOUND";
export const REINIT_ALERT_MESSAGE = "REINIT_ALERT_MESSAGE";
/**********EXECUTIONS******** */
export const FETCH_MY_EXECUTIONS_START = "FETCH_MY_EXECUTIONS_START";
export const FETCH_MY_EXECUTIONS_SUCCESS = "FETCH_MY_EXECUTIONS_SUCCESS";
export const FETCH_MY_EXECUTIONS_FAIL = "FETCH_MY_EXECUTIONS_FAIL";

export const RENAME_EXECUTION_START = "RENAME_EXECUTION_START";
export const RENAME_EXECUTION_SUCCESS = "RENAME_EXECUTION_SUCCESS";
export const RENAME_EXECUTION_FAIL = "RENAME_EXECUTION_FAIL";

export const FETCH_APP_EXECUTION_START = "FETCH_APP_EXECUTION_START";
export const FETCH_APP_EXECUTION_SUCCESS = "FETCH_APP_EXECUTION_SUCCESS";
export const UPDATE_APP_EXECUTION = "UPDATE_APP_EXECUTION";
export const FETCH_APP_EXECUTION_FAIL = "FETCH_APP_EXECUTION_FAIL";
export const REINIT_APP_EXECUTION = "REINIT_APP_EXECUTION";

export const UPDATE_EXECUTION_LIST_START = "UPDATE_EXECUTION_LIST_START";
export const UPDATE_EXECUTION_LIST_SUCCESS = "UPDATE_EXECUTION_LIST_SUCCESS";
export const UPDATE_EXECUTION_LIST_FAIL = "UPDATE_EXECUTION_LIST_FAIL";

export const FETCH_MODEL_EXECUTION_DETAILS_START = "FETCH_MODEL_EXECUTION_DETAILS_START";
export const FETCH_MODEL_EXECUTION_DETAILS_SUCCESS = "FETCH_MODEL_EXECUTION_DETAILS_SUCCESS";
export const FETCH_MODEL_EXECUTION_DETAILS_FAIL = "FETCH_MODEL_EXECUTION_DETAILS_FAIL";
export const REINIT_EXECUTION_LIST = "REINIT_EXECUTION_LIST";

/*********** QUALITYCHECK ACTIONS **************/
export const ADD_NEW_CAMERA_START = "ADD_NEW_CAMERA_START";
export const ADD_NEW_CAMERA_SUCCESS = "ADD_NEW_CAMERA_SUCCESS";
export const ADD_NEW_CAMERA_FAIL = "ADD_NEW_CAMERA_FAIL";

export const DELETE_CAMERA_START = "DELETE_CAMERA_START";
export const DELETE_CAMERA_SUCCESS = "DELETE_CAMERA_SUCCESS";
export const DELETE_CAMERA_FAIL = "DELETE_CAMERA_FAIL";

export const CAMERA_CONNECT_START = "CAMERA_CONNECT_START";
export const CAMERA_CONNECT_SUCCESS = "CAMERA_CONNECT_SUCCESS";
export const CAMERA_CONNECT_FAIL = "CAMERA_CONNECT_FAIL";

export const CAMERA_DISCONNECT_START = "CAMERA_DISCONNECT_START";
export const CAMERA_DISCONNECT_SUCCESS = "CAMERA_DISCONNECT_SUCCESS";
export const CAMERA_DISCONNECT_FAIL = "CAMERA_DISCONNECT_FAIL";

export const SELECT_CAMERA = "SELECT_CAMERA";

export const FETCH_CAMERAS_START_OLD = "FETCH_CAMERAS_START_OLD";
export const FETCH_CAMERAS_SUCCESS_OLD = "FETCH_CAMERAS_SUCCESS_OLD";
export const FETCH_CAMERAS_FAIL_OLD = "FETCH_CAMERAS_FAIL_OLD";

export const REQUEST_SERVE_MODEL_START = "REQUEST_SERVE_MODEL_START";
export const REQUEST_SERVE_MODEL_SUCCESS = "REQUEST_SERVE_MODEL_SUCCESS";
export const REQUEST_SERVE_MODEL_FAIL = "REQUEST_SERVE_MODEL_FAIL";

export const CHECK_FOR_TF_START = "CHECK_FOR_TF_START";
export const CHECK_FOR_TF_SUCCESS = "CHECK_FOR_TF_SUCCESS";
export const CHECK_FOR_TF_FAIL = "CHECK_FOR_TF_FAIL";

export const FETCH_SERVABLE_MODELS_START = "FETCH_SERVABLE_MODELS_START";
export const FETCH_SERVABLE_MODELS_SUCCESS = "FETCH_SERVABLE_MODELS_SUCCESS";
export const FETCH_SERVABLE_MODELS_FAIL = "FETCH_SERVABLE_MODELS_FAIL";

export const DELETE_SERVABLE_MODEL_START = "DELETE_SERVABLE_MODEL_START";
export const DELETE_SERVABLE_MODEL_SUCCESS = "DELETE_SERVABLE_MODEL_SUCCESS";
export const DELETE_SERVABLE_MODEL_FAIL = "DELETE_SERVABLE_MODEL_FAIL";

export const FETCH_BATCH_PREDICTION_MONITORS_START = "FETCH_BATCH_PREDICTION_MONITORS_START";
export const FETCH_BATCH_PREDICTION_MONITORS_SUCCESS = "FETCH_BATCH_PREDICTION_MONITORS_SUCCESS";
export const FETCH_BATCH_PREDICTION_MONITORS_FAIL = "FETCH_BATCH_PREDICTION_MONITORS_FAIL";

export const FETCH_BATCH_PREDICTION_MONITOR_START = "FETCH_BATCH_PREDICTION_MONITOR_START";
export const FETCH_BATCH_PREDICTION_MONITOR_SUCCESS = "FETCH_BATCH_PREDICTION_MONITOR_SUCCESS";
export const FETCH_BATCH_PREDICTION_MONITOR_FAIL = "FETCH_BATCH_PREDICTION_MONITOR_FAIL";

export const FETCH_BATCH_PREDICTION_MONITOR_DATA_START = "FETCH_BATCH_PREDICTION_MONITOR_DATA_START";
export const FETCH_BATCH_PREDICTION_MONITOR_DATA_SUCCESS = "FETCH_BATCH_PREDICTION_MONITOR_DATA_SUCCESS";
export const FETCH_BATCH_PREDICTION_MONITOR_DATA_FAIL = "FETCH_BATCH_PREDICTION_MONITOR_DATA_FAIL";

export const FETCH_BATCH_PREDICTION_MONITOR_ACTIVE_DAYS_SUCCESS = "FETCH_BATCH_PREDICTION_MONITOR_ACTIVE_DAYS_SUCCESS";

export const FETCH_BATCH_PREDICTION_MONITOR_FILES_START = "FETCH_BATCH_PREDICTION_MONITOR_FILES_START";
export const FETCH_BATCH_PREDICTION_MONITOR_FILES_SUCCESS = "FETCH_BATCH_PREDICTION_MONITOR_FILES_SUCCESS";
export const FETCH_BATCH_PREDICTION_MONITOR_FILES_FAIL = "FETCH_BATCH_PREDICTION_MONITOR_FILES_FAIL";

export const FETCH_BATCH_PREDICTION_FEEDBACK_PROJECTS_START = "FETCH_BATCH_PREDICTION_FEEDBACK_PROJECTS_START";
export const FETCH_BATCH_PREDICTION_FEEDBACK_PROJECTS_SUCCESS = "FETCH_BATCH_PREDICTION_FEEDBACK_PROJECTS_SUCCESS";
export const FETCH_BATCH_PREDICTION_FEEDBACK_PROJECTS_FAIL = "FETCH_BATCH_PREDICTION_FEEDBACK_PROJECTS_FAIL";

export const PUSH_BATCH_PREDICTION_FEEDBACK_IMAGE_SUCCESS = "PUSH_BATCH_PREDICTION_FEEDBACK_IMAGE_SUCCESS";
export const CREATE_BATCH_PREDICTION_FEEDBACK_PROJECTS_SUCCESS = "CREATE_BATCH_PREDICTION_FEEDBACK_PROJECTS_SUCCESS";

export const FETCH_HOYA_ALERTS_LIST_START = "FETCH_HOYA_ALERTS_LIST_START";
export const FETCH_HOYA_ALERTS_LIST_FAIL = "FETCH_HOYA_ALERTS_LIST_FAIL";
export const FETCH_HOYA_ALERTS_LIST_SUCCESS = "FETCH_HOYA_ALERTS_LIST_SUCCESS";

export const FETCH_HOYA_ALERT_START = "FETCH_HOYA_ALERT_START";
export const FETCH_HOYA_ALERT_FAIL = "FETCH_HOYA_ALERT_FAIL";
export const FETCH_HOYA_ALERT_SUCCESS = "FETCH_HOYA_ALERT_SUCCESS";

export const DELETE_HOYA_ALERT_START = "DELETE_HOYA_ALERT_START";
export const DELETE_HOYA_ALERT_FAIL = "DELETE_HOYA_ALERT_FAIL";
export const DELETE_HOYA_ALERT_SUCCESS = "DELETE_HOYA_ALERT_SUCCESS";

export const FETCH_HOYA_ALERT_OPTIONS_START = "FETCH_HOYA_ALERT_OPTIONS_START";
export const FETCH_HOYA_ALERT_OPTIONS_FAIL = "FETCH_HOYA_ALERT_OPTIONS_FAIL";
export const FETCH_HOYA_ALERT_OPTIONS_SUCCESS = "FETCH_HOYA_ALERT_OPTIONS_SUCCESS";

export const UPDATE_HOYA_ALERT_START = "UPDATE_HOYA_ALERT_START";
export const UPDATE_HOYA_ALERT_FAIL = "UPDATE_HOYA_ALERT_FAIL";
export const UPDATE_HOYA_ALERT_SUCCESS = "UPDATE_HOYA_ALERT_SUCCESS";

/*********** Fetch Batch Prediction Output **************/
export const FETCH_BATCH_PREDICTION_OUTPUT_START = "FETCH_BATCH_PREDICTION_OUTPUT_START";
export const FETCH_BATCH_PREDICTION_OUTPUT_SUCCESS = "FETCH_BATCH_PREDICTION_OUTPUT_SUCCESS";
export const FETCH_BATCH_PREDICTION_OUTPUT_FAIL = "FETCH_BATCH_PREDICTION_OUTPUT_FAIL";
export const FETCH_IMAGE_PREDICTION_DETAILS = "FETCH_IMAGE_PREDICTION_DETAILS";
export const REINIT_BATCH_PREDICTIONS = "REINIT_BATCH_PREDICTIONS";

export const REINIT_BATCH_LIST = "REINIT_BATCH_LIST";

/*********** Fetch Single Prediction Output **************/
export const FETCH_SINGLE_PREDICTION_OUTPUT_START = "FETCH_SINGLE_PREDICTION_OUTPUT_START";
export const FETCH_SINGLE_PREDICTION_OUTPUT_SUCCESS = "FETCH_SINGLE_PREDICTION_OUTPUT_SUCCESS";
export const FETCH_SINGLE_PREDICTION_OUTPUT_FAIL = "FETCH_SINGLE_PREDICTION_OUTPUT_FAIL";
/*********** Fetch Batch Prediction Output **************/
export const REFRESH_CSV_OUTPUT_LINK_START = "REFRESH_CSV_OUTPUT_LINK_START";
export const REFRESH_CSV_OUTPUT_LINK_SUCCESS = "REFRESH_CSV_OUTPUT_LINK_SUCCESS";
export const REFRESH_CSV_OUTPUT_LINK_FAIL = "REFRESH_CSV_OUTPUT_LINK_FAIL";

/*********** Fetch Batch Prediction Table **************/
export const DOWNLOAD_FILE = "DOWNLOAD_FILE";
export const DOWNLOAD_FILE_START = "DOWNLOAD_FILE_START";
export const DOWNLOAD_FILE_SUCCESS = "DOWNLOAD_FILE_SUCCESS";
export const DOWNLOAD_FILE_FAIL = "DOWNLOAD_FILE_FAIL";

export const DOWNLOAD_EXEC_LOGS_START = "DOWNLOAD_EXEC_LOGS_START";
export const DOWNLOAD_EXEC_LOGS_SUCCESS = "DOWNLOAD_EXEC_LOGS_SUCCESS";
export const DOWNLOAD_EXEC_LOGS_FAIL = "DOWNLOAD_EXEC_LOGS_FAIL";
/*********** Manage Applications **************/
// Index
export const FETCH_APPLICATIONS = "FETCH_APPLICATIONS";
export const FETCH_APPLICATIONS_START = "FETCH_APPLICATIONS_START";
export const FETCH_APPLICATIONS_SUCCESS = "FETCH_APPLICATIONS_SUCCESS";
export const FETCH_APPLICATIONS_FAIL = "FETCH_APPLICATIONS_FAIL";
// Delete
export const DELETE_APPLICATION = "DELETE_APPLICATION";
export const DELETE_APPLICATION_START = "DELETE_APPLICATION_START";
export const DELETE_APPLICATION_SUCCESS = "DELETE_APPLICATION_SUCCESS";
export const DELETE_APPLICATION_FAIL = "DELETE_APPLICATION_FAIL";
// Show
export const FETCH_AN_APPLICATION = "FETCH_AN_APPLICATION";
export const FETCH_AN_APPLICATION_START = "FETCH_AN_APPLICATION_START";
export const FETCH_AN_APPLICATION_SUCCESS = "FETCH_AN_APPLICATION_SUCCESS";
export const FETCH_AN_APPLICATION_FAIL = "FETCH_AN_APPLICATION_FAIL";
// Create
export const CREATE_NEW_APPLICATION = "CREATE_NEW_APPLICATION";
export const CREATE_NEW_APPLICATION_START = "CREATE_NEW_APPLICATION_START";
export const CREATE_NEW_APPLICATION_SUCCESS = "CREATE_NEW_APPLICATION_SUCCESS";
export const CREATE_NEW_APPLICATION_FAIL = "CREATE_NEW_APPLICATION_FAIL";

export const CREATE_EXISTING_APPLICATION_START = "CREATE_EXISTING_APPLICATION_START";
export const CREATE_EXISTING_APPLICATION_SUCCESS = "CREATE_EXISTING_APPLICATION_SUCCESS";
export const CREATE_EXISTING_APPLICATION_FAIL = "CREATE_EXISTING_APPLICATION_FAIL";
// Edit
export const EDIT_APPLICATION = "EDIT_APPLICATION";
export const EDIT_APPLICATION_START = "EDIT_APPLICATION_START";
export const EDIT_APPLICATION_SUCCESS = "EDIT_APPLICATION_SUCCESS";
export const EDIT_APPLICATION_FAIL = "EDIT_APPLICATION_FAIL";

/*********** run execution **************/
export const RUN_EXECUTION_START = "RUN_EXECUTION_START";
export const RUN_EXECUTION_SUCCESS = "RUN_EXECUTION_SUCCESS";
export const RUN_EXECUTION_FAIL = "RUN_EXECUTION_FAIL";

export const RUN_EXECUTION_TYPE = "RUN_EXECUTION_TYPE";

export const STOP_EXECUTION_START = "STOP_EXECUTION_START";
export const STOP_EXECUTION_SUCCESS = "STOP_EXECUTION_SUCCESS";
export const STOP_EXECUTION_FAIL = "STOP_EXECUTION_FAIL";

export const UPDATE_EXECUTIONS_STATUS = "UPDATE_EXECUTIONS_STATUS";
export const UPDATE_EXECUTIONS_PROGRESS = "UPDATE_EXECUTIONS_PROGRESS";

/*********** run dataset analysis **************/
export const RUN_DATASET_ANALYSIS_START = "RUN_DATASET_ANALYSIS_START";
export const RUN_DATASET_ANALYSIS_SUCCESS = "RUN_DATASET_ANALYSIS_SUCCESS";
export const RUN_DATASET_ANALYSIS_FAIL = "RUN_DATASET_ANALYSIS_FAIL";
export const SET_ANALYSIS_ERROR = "SET_ANALYSIS_ERROR";

/*********** fetch object detection data **************/
export const FETCH_OBJECT_DETECTION_DATA_START = "FETCH_OBJECT_DETECTION_DATA_START";
export const FETCH_OBJECT_DETECTION_DATA_SUCCESS = "FETCH_OBJECT_DETECTION_DATA_SUCCESS";
export const FETCH_OBJECT_DETECTION_DATA_FAIL = "FETCH_OBJECT_DETECTION_DATA_FAIL";

/*********** connectors data **************/
export const CREATE_CONNECTOR_START = "CREATE_CONNECTOR_START";
export const CREATE_CONNECTOR_SUCCESS = "CREATE_CONNECTOR_SUCCESS";
export const CREATE_CONNECTOR_FAIL = "CREATE_CONNECTOR_FAIL";

export const FETCH_CONNECTORS_START = "FETCH_CONNECTORS_START";
export const FETCH_CONNECTORS_SUCCESS = "FETCH_CONNECTORS_SUCCESS";
export const FETCH_CONNECTORS_FAIL = "FETCH_CONNECTORS_FAIL";

export const DELETE_CONNECTOR_START = "DELETE_CONNECTOR_START";
export const DELETE_CONNECTOR_SUCCESS = "DELETE_CONNECTOR_SUCCESS";
export const DELETE_CONNECTOR_FAIL = "DELETE_CONNECTOR_FAIL";

/*********** recurrentBatch data **************/
export const FETCH_RECURRENT_BATCH_PREDICTIONS_START = "FETCH_RECURRENT_BATCH_PREDICTIONS_START";
export const FETCH_RECURRENT_BATCH_PREDICTIONS_SUCCESS = "FETCH_RECURRENT_BATCH_PREDICTIONS_SUCCESS";
export const FETCH_RECURRENT_BATCH_PREDICTIONS_FAIL = "FETCH_RECURRENT_BATCH_PREDICTIONS_FAIL";

export const DELETE_RECURRENT_BATCH_PREDICTION_START = "DELETE_RECURRENT_BATCH_PREDICTION_START";
export const DELETE_RECURRENT_BATCH_PREDICTION_SUCCESS = "DELETE_RECURRENT_BATCH_PREDICTION_SUCCESS";
export const DELETE_RECURRENT_BATCH_PREDICTION_FAIL = "DELETE_RECURRENT_BATCH_PREDICTION_FAIL";

export const CREATE_RECURRENT_BATCH_PREDICTION_START = "CREATE_RECURRENT_BATCH_PREDICTION_START";
export const CREATE_RECURRENT_BATCH_PREDICTION_SUCCESS = "CREATE_RECURRENT_BATCH_PREDICTION_SUCCESS";
export const CREATE_RECURRENT_BATCH_PREDICTION_FAIL = "CREATE_RECURRENT_BATCH_PREDICTION_FAIL";

export const CHANGE_RECURRENT_BATCH_PREDICTION_STATUS_START = "CHANGE_RECURRENT_BATCH_PREDICTION_STATUS_START";
export const CHANGE_RECURRENT_BATCH_PREDICTION_STATUS_SUCCESS = "CHANGE_RECURRENT_BATCH_PREDICTION_STATUS_SUCCESS";
export const CHANGE_RECURRENT_BATCH_PREDICTION_STATUS_FAIL = "CHANGE_RECURRENT_BATCH_PREDICTION_STATUS_FAIL";

/*********** admin dashboard / manage users **************/
export const FETCH_USERS_LIST_START = "FETCH_USERS_LIST_START";
export const FETCH_USERS_LIST_SUCCESS = "FETCH_USERS_LIST_SUCCESS";
export const FETCH_USERS_LIST_FAIL = "FETCH_USERS_LIST_FAIL";

export const DELETE_USER_START = "DELETE_USER_START";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAIL = "DELETE_USER_FAIL";

export const UPDATE_USER_START = "UPDATE_USER_START";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";

export const FETCH_SINGLE_USER_START = "FETCH_SINGLE_USER_START";
export const FETCH_SINGLE_USER_SUCCESS = "FETCH_SINGLE_USER_SUCCESS";
export const FETCH_SINGLE_USER_FAIL = "FETCH_SINGLE_USER_FAIL";

export const FETCH_SINGLE_USER_STATISTICS_START = "FETCH_SINGLE_USER_STATISTICS_START";
export const FETCH_SINGLE_USER_STATISTICS_SUCCESS = "FETCH_SINGLE_USER_STATISTICS_SUCCESS";
export const FETCH_SINGLE_USER_STATISTICS_FAIL = "FETCH_SINGLE_USER_STATISTICS_FAIL";

/*********** admin dashboard / manage organizations **************/
export const FETCH_ORGANIZATIONS_LIST = "FETCH_ORGANIZATIONS_LIST";
export const FETCH_ORGANIZATIONS_LIST_START = "FETCH_ORGANIZATIONS_LIST_START";
export const FETCH_ORGANIZATIONS_LIST_SUCCESS = "FETCH_ORGANIZATIONS_LIST_SUCCESS";
export const FETCH_ORGANIZATIONS_LIST_FAIL = "FETCH_ORGANIZATIONS_LIST_FAIL";

export const FETCH_ORGANIZATIONS_STATISTICS_START = "FETCH_ORGANIZATIONS_STATISTICS_START";
export const FETCH_ORGANIZATIONS_STATISTICS_SUCCESS = "FETCH_ORGANIZATIONS_STATISTICS_SUCCESS";
export const FETCH_ORGANIZATIONS_STATISTICS_FAIL = "FETCH_ORGANIZATIONS_STATISTICS_FAIL";

export const DELETE_ORGANIZATION = "DELETE_ORGANIZATION";
export const DELETE_ORGANIZATION_START = "DELETE_ORGANIZATION_START";
export const DELETE_ORGANIZATION_SUCCESS = "DELETE_ORGANIZATION_SUCCESS";
export const DELETE_ORGANIZATION_FAIL = "DELETE_ORGANIZATION_FAIL";

export const CREATE_ORGANIZATION = "CREATE_ORGANIZATION";
export const CREATE_ORGANIZATION_START = "CREATE_ORGANIZATION_START";
export const CREATE_ORGANIZATION_SUCCESS = "CREATE_ORGANIZATION_SUCCESS";
export const CREATE_ORGANIZATION_FAIL = "CREATE_ORGANIZATION_FAIL";

export const FETCH_ORGANIZATION_START = "FETCH_ORGANIZATION_START";
export const FETCH_ORGANIZATION_SUCCESS = "FETCH_ORGANIZATION_SUCCESS";
export const FETCH_ORGANIZATION_FAIL = "FETCH_ORGANIZATION_FAIL";

export const EDIT_ORGANIZATION_START = "EDIT_ORGANIZATION_START";
export const EDIT_ORGANIZATION_SUCCESS = "EDIT_ORGANIZATION_SUCCESS";
export const EDIT_ORGANIZATION_FAIL = "EDIT_ORGANIZATION_FAIL";

/*********** admin dashboard / manage roles **************/
export const FETCH_ROLES_LIST_START = "FETCH_ROLES_LIST_START";
export const FETCH_ROLES_LIST_SUCCESS = "FETCH_ROLES_LIST_SUCCESS";
export const FETCH_ROLES_LIST_FAIL = "FETCH_ROLES_LIST_FAIL";

export const CREATE_ROLE_START = "CREATE_ROLE_START";
export const CREATE_ROLE_SUCCESS = "CREATE_ROLE_SUCCESS";
export const CREATE_ROLE_FAIL = "CREATE_ROLE_FAIL";

export const DELETE_ROLE_START = "DELETE_ROLE_START";
export const DELETE_ROLE_FAIL = "DELETE_ROLE_FAIL";
export const DELETE_ROLE_SUCCESS = "DELETE_ROLE_SUCCESS";

export const FETCH_PERMISSIONS_LIST_START = "FETCH_PERMISSIONS_LIST_START";
export const FETCH_PERMISSIONS_LIST_SUCCESS = "FETCH_PERMISSIONS_LIST_SUCCESS";
export const FETCH_PERMISSIONS_LIST_FAIL = "FETCH_PERMISSIONS_LIST_FAIL";

/*********** settings / invitations **************/
export const FETCH_INVITATIONS_LIST_START = "FETCH_INVITATIONS_LIST_START";
export const FETCH_INVITATIONS_LIST_SUCCESS = "FETCH_INVITATIONS_LIST_SUCCESS";
export const FETCH_INVITATIONS_LIST_FAIL = "FETCH_INVITATIONS_LIST_FAIL";

export const DELETE_INVITATION_START = "DELETE_INVITATION_START";
export const DELETE_INVITATION_FAIL = "DELETE_INVITATION_FAIL";
export const DELETE_INVITATION_SUCCESS = "DELETE_INVITATION_SUCCESS";

export const SEND_INVITATION_START = "SEND_INVITATION_START";
export const SEND_INVITATION_FAIL = "SEND_INVITATION_FAIL";
export const SEND_INVITATION_SUCCESS = "SEND_INVITATION_SUCCESS";

export const ADD_IOT_SYSTEM_START = "ADD_IOT_SYSTEM_START";
export const ADD_IOT_SYSTEM_FAIL = "ADD_IOT_SYSTEM_FAIL";
export const ADD_IOT_SYSTEM_SUCCESS = "ADD_IOT_SYSTEM_SUCCESS";

/*********** authorization **************/
export const FETCH_USER_PERMISSIONS_START = "FETCH_USER_PERMISSIONS_START";
export const FETCH_USER_PERMISSIONS_SUCCESS = "FETCH_USER_PERMISSIONS_SUCCESS";
export const FETCH_USER_PERMISSIONS_FAIL = "FETCH_USER_PERMISSIONS_FAIL";

/*********** resources ******************/
export const FETCH_RESOURCES_START = "FETCH_RESOURCES_START";
export const FETCH_RESOURCES_SUCCESS = "FETCH_RESOURCES_SUCCESS";
export const FETCH_RESOURCES_FAIL = "FETCH_RESOURCES_FAIL";

export const STOP_MACHINE_READINGS_STREAMING = "STOP_MACHINE_READINGS_STREAMING";
export const FETCH_MACHINE_PREDICTIONS_SUCCESS = "FETCH_MACHINE_PREDICTIONS_SUCCESS";

export const MACHINE_TEST_DEVICE_CONNECTION_START = "MACHINE_TEST_DEVICE_CONNECTION_START";
export const MACHINE_TEST_DEVICE_CONNECTION_SUCCESS = "MACHINE_TEST_DEVICE_CONNECTION_SUCCESS";
export const MACHINE_TEST_DEVICE_CONNECTION_FAIL = "MACHINE_TEST_DEVICE_CONNECTION_FAIL";

export const FETCH_MACHINES_MODELS_LIST_START = "FETCH_MACHINES_MODELS_LIST_START";
export const FETCH_MACHINES_MODELS_LIST_FAIL = "FETCH_MACHINES_MODELS_LIST_FAIL";
export const FETCH_MACHINES_MODELS_LIST_SUCCESS = "FETCH_MACHINES_MODELS_LIST_SUCCESS";
export const FETCH_MACHINES_MODELS_LIST_RESET = "FETCH_MACHINES_MODELS_LIST_RESET";

export const FETCH_MACHINE_MODEL_START = "FETCH_MACHINE_MODEL_START";
export const FETCH_MACHINE_MODEL_FAIL = "FETCH_MACHINE_MODEL_FAIL";
export const FETCH_MACHINE_MODEL_SUCCESS = "FETCH_MACHINE_MODEL_SUCCESS";
export const FETCH_MACHINE_MODEL_RESET = "FETCH_MACHINE_MODEL_RESET";

export const FETCH_MACHINE_MODEL_PREDICTIONS_START = "FETCH_MACHINE_MODEL_PREDICTIONS_START";
export const FETCH_MACHINE_MODEL_PREDICTIONS_FAIL = "FETCH_MACHINE_MODEL_PREDICTIONS_FAIL";
export const FETCH_MACHINE_MODEL_PREDICTIONS_SUCCESS = "FETCH_MACHINE_MODEL_PREDICTIONS_SUCCESS";
export const STOP_MACHINE_MODEL_PREDICTIONS_STREAMING = "STOP_MACHINE_MODEL_PREDICTIONS_STREAMING";

export const CREATE_MACHINE_MODEL_START = "CREATE_MACHINE_MODEL_START";
export const CREATE_MACHINE_MODEL_FAIL = "CREATE_MACHINE_MODEL_FAIL";
export const CREATE_MACHINE_MODEL_SUCCESS = "CREATE_MACHINE_MODEL_SUCCESS";

export const FETCH_SERVABLE_MODELS_LIST_START = "FETCH_SERVABLE_MODELS_LIST_START";
export const FETCH_SERVABLE_MODELS_LIST_FAIL = "FETCH_SERVABLE_MODELS_LIST_FAIL";
export const FETCH_SERVABLE_MODELS_LIST_SUCCESS = "FETCH_SERVABLE_MODELS_LIST_SUCCESS";
export const FETCH_SERVABLE_MODELS_LIST_RESET = "FETCH_SERVABLE_MODELS_LIST_RESET";

export const CONNECT_MACHINE_MODEL_START = "CONNECT_MACHINE_MODEL_START";
export const CONNECT_MACHINE_MODEL_FAIL = "CONNECT_MACHINE_MODEL_FAIL";
export const CONNECT_MACHINE_MODEL_SUCCESS = "CONNECT_MACHINE_MODEL_SUCCESS";

export const DISCONNECT_MACHINE_MODEL_START = "DISCONNECT_MACHINE_MODEL_START";
export const DISCONNECT_MACHINE_MODEL_FAIL = "DISCONNECT_MACHINE_MODEL_FAIL";
export const DISCONNECT_MACHINE_MODEL_SUCCESS = "DISCONNECT_MACHINE_MODEL_SUCCESS";

export const DELETE_MACHINE_MODEL_START = "DELETE_MACHINE_MODEL_START";
export const DELETE_MACHINE_MODEL_FAIL = "DELETE_MACHINE_MODEL_FAIL";
export const DELETE_MACHINE_MODEL_SUCCESS = "DELETE_MACHINE_MODEL_SUCCESS";

export const CHECK_DEPLOY_MODEL_LIMIT_START = "CHECK_DEPLOY_MODEL_LIMIT_START";
export const CHECK_DEPLOY_MODEL_LIMIT_SUCCESS = "CHECK_DEPLOY_MODEL_LIMIT_SUCCESS";
export const CHECK_DEPLOY_MODEL_LIMIT_FAIL = "CHECK_DEPLOY_MODEL_LIMIT_FAIL";
/*********************************** Cameras ************************************/
// LIST
export const FETCH_CAMERAS_START = "FETCH_CAMERAS_START";
export const FETCH_CAMERAS_SUCCESS = "FETCH_CAMERAS_SUCCESS";
export const FETCH_CAMERAS_FAIL = "FETCH_CAMERAS_FAIL";
// SINGLE
export const FETCH_SINGLE_CAMERA_START = "FETCH_SINGLE_CAMERA_START";
export const FETCH_SINGLE_CAMERA_IMAGES_START = "FETCH_SINGLE_CAMERA_IMAGES_START";
export const FETCH_SINGLE_CAMERA_SUCCESS = "FETCH_SINGLE_CAMERA_SUCCESS";
export const FETCH_SINGLE_CAMERA_IMAGES_SUCCESS = "FETCH_SINGLE_CAMERA_IMAGES_SUCCESS";
export const FETCH_SINGLE_CAMERA_FAIL = "FETCH_SINGLE_CAMERA_FAIL";
export const FETCH_SINGLE_CAMERA_IMAGES_FAIL = "FETCH_SINGLE_CAMERA_IMAGES_FAIL";
// IMAGE
export const FETCH_SINGLE_IMAGE_START = "FETCH_SINGLE_IMAGE_START";
export const FETCH_SINGLE_IMAGE_SUCCESS = "FETCH_SINGLE_IMAGE_SUCCESS";
export const FETCH_SINGLE_IMAGE_FAIL = "FETCH_SINGLE_IMAGE_FAIL";
// STREAMING
export const START_CAMERA_STREAMING = "START_CAMERA_STREAMING";
export const STOP_CAMERA_STREAMING = "STOP_CAMERA_STREAMING";
// CONNECTION
export const CONNECT_CAMERA_START = "CONNECT_CAMERA_START";
export const CONNECT_CAMERA_SUCCESS = "CONNECT_CAMERA_SUCCESS";
export const CONNECT_CAMERA_FAIL = "CONNECT_CAMERA_FAIL";
export const DISCONNECT_CAMERA_START = "DISCONNECT_CAMERA_START";
export const DISCONNECT_CAMERA_SUCCESS = "DISCONNECT_CAMERA_SUCCESS";
export const DISCONNECT_CAMERA_FAIL = "DISCONNECT_CAMERA_FAIL";
// CREATE
export const CREATE_CAMERA_START = "CREATE_CAMERA_START";
export const CREATE_CAMERA_SUCCESS = "CREATE_CAMERA_SUCCESS";
export const CREATE_CAMERA_FAIL = "CREATE_CAMERA_FAIL";
// REINIT
export const REINIT_CAMERAS = "REINIT_CAMERAS";
// EDIT
export const EDIT_CAMERA_START = "EDIT_CAMERA_START";
export const EDIT_CAMERA_SUCCESS = "EDIT_CAMERA_SUCCESS";
export const EDIT_CAMERA_FAIL = "EDIT_CAMERA_FAIL";
// TEST
export const TEST_CAMERA_START = "TEST_CAMERA_START";
export const TEST_CAMERA_SUCCESS = "TEST_CAMERA_SUCCESS";
export const TEST_CAMERA_FAIL = "TEST_CAMERA_FAIL";

export const DELETE_MACHINE_MODEL_CONNECTION_START = "DELETE_MACHINE_MODEL_CONNECTION_START";
export const DELETE_MACHINE_MODEL_CONNECTION_SUCCESS = "DELETE_MACHINE_MODEL_CONNECTION_SUCCESS";
export const DELETE_MACHINE_MODEL_CONNECTION_FAIL = "DELETE_MACHINE_MODEL_CONNECTION_FAIL";
